import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { MillLocalserverEntity } from "entities/MillLocalserver/MillLocalserverEntity";
import { IMillLocalserverLiveStatusContextProps } from "./MillLocalserverLiveStatusContextInterfaces";
import { MillLocalserverLiveStatusContext } from "./MillLocalserverLiveStatusContext";

export const MillLocalserverLiveStatusProvider: React.FC<IMillLocalserverLiveStatusContextProps> = ({ children }) => {
    const { millId } = useParams();
    const millIdMemoized = useMemo(() => (Boolean(millId) ? Number(millId) : 0), [millId]);

    const { isDisconnected, loading, error } = MillLocalserverEntity.GetLocalserverCurrentStatus(millIdMemoized);

    const providerValue = {
        loading,
        isDisconnected,
        error,
    };

    return (
        <MillLocalserverLiveStatusContext.Provider value={providerValue}>
            {children}
        </MillLocalserverLiveStatusContext.Provider>
    );
};
